import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-access-denied',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './access-denied.component.html',
  styleUrl: './access-denied.component.scss',
})
export class AccessDeniedComponent {
  @Input() title = 'Access not found';
  @Input() message = '';
  @Input() hint = 'If you believe this a mistake,please get in touch with Luke Hayward(luke.hayward@cummins.com)';
}
